<script setup>
import { PopoverPortal, PopoverRoot, PopoverTrigger } from 'reka-ui'

const { portal } = defineProps({
    side: { type: String, default: 'bottom' },
    sideOffset: { type: Number, default: 5 },
    label: { type: String, default: 'Popover' },
    portal: { type: Boolean, default: true },
})

const emit = defineEmits(['openChange'])

const open = defineModel('open', { type: Boolean, default: false })
const triggerRef = ref(null)

useScroll(window, {
    onScroll(e) {
        const target = e.target
        if (open.value && triggerRef.value && target instanceof Node && target.contains(triggerRef.value)) {
            open.value = false
        }
    },
    eventListenerOptions: { capture: true, passive: true },
})

watch(open, (val) => emit('openChange', val))

const inDialog = inject('inDialog', false)
// Disable portal when inside a Dialog so content renders inline within the dialog's
// DOM tree. This keeps it inside the dialog's focus trap, preventing interaction
// and focus events from being blocked by the dialog's pointer-events/overlay.
const resolvedPortal = computed(() => portal && !inDialog)
</script>

<template>
    <PopoverRoot v-slot="{ close, open: isOpen }" v-model:open="open">
        <div ref="triggerRef" style="display: contents">
            <PopoverTrigger as-child :aria-label="label" @click.stop.prevent>
                <slot name="trigger" />
            </PopoverTrigger>
        </div>
        <PopoverPortal :disabled="!resolvedPortal">
            <slot v-if="isOpen" name="content" :close="close" />
        </PopoverPortal>
    </PopoverRoot>
</template>
